<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">公司名称</span>
            <el-input
              v-model="listQuery.companyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">发票抬头</span>
            <el-input
              v-model="listQuery.titleName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box" v-if="showSalesManFilter()">
            <span class="label">业务代表</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">审批状态</span>
            <el-select :filterable="true" v-model="listQuery.changeStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in ReviewStatusOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">开始日期</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">结束日期</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>

        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{isFilterCollapse ? '展开' : '收起'}}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')" >
            <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
            <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <TableList
        ref="tableListRef"
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :isShowPagination="false"
        :canRefresh="false"
        :canChangeColumn="false"
        @command-change="handleCommand"
        :highlightCurrentRow="true"
      >
        <template v-slot:titleName="scope">
          <span :class="scope.row.status === 1 ? 'redStatusStyle' : scope.row.status === 2 ? 'yellowStatusStyle' : ''" class="statusStyle">
            <i class="iconfont icon-tubiao-40" v-if="scope.row.status !== 3"></i>
            <span class="status">{{ReviewStatusOption.find(k => k.id === scope.row.status) ? ReviewStatusOption.find(k => k.id === scope.row.status).mark : ''}} </span>

            <span>{{scope.row.titleName}} </span>
          </span>
        </template>
        <template v-slot:customerCompanyId="scope">
          <span>{{scope.row.customerCompanyName }} </span>
        </template>
        <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_APPROVAL` }"
            v-if="scope.row.status == 1"
            href="javascript:void(0);"
            class="mr-10"
            type="primary"
            @click="handleCommand('edit', scope.row)"
          >
            审批
          </el-link>
        </template>
      </TableList>
      <el-pagination
        class="mt-20"
        v-show="total > 0"
        :total="total"
        v-model:currentPage="listQuery.page"
        :page-size="listQuery.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </div>
    <div v-if="dialogFormVisible">
      <div style="display:flex">
        <FormComponent
          :id="activeId"
          :initFormData="initFormData"
          :fromFieldData="originFromFieldData"
          :dialogFormVisible="dialogFormVisible"
          :api="'customerCompanyTicketTitle'"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          :formDisabled="true"
        />
        <FormComponent
          :id="activeId"
          :initFormData="initFormData"
          :fromFieldData="targetFromFieldData"
          :dialogFormVisible="dialogFormVisible"
          :api="'customerCompanyTicketTitle'"
          :isShowCloseBtn="false"
          :isShowSubmitBtn="false"
          :formDisabled="true"
        />
      </div>
      <div class="dialog-footer mt-20">
        <el-button @click="dialogFormVisible = false" >
          {{ t("table.cancel") }}
        </el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="handleSubmit('approve')"
        >
          通过
        </el-button>
        <el-button
          type="danger"
          :loading="submitLoading"
          @click="handleSubmit('reject')"
        >
          拒绝
        </el-button>
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { useStore } from '@/store'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import { cloneDeep } from 'lodash'
import { ElMessage } from 'element-plus'
import { reviewCompanyTicketTitleById, getReviewCompanyTicketTitleList, reviewApproveTicketTitle, reviewRejectTicketTitle } from '@/apis/CustomerCompanyTicketTitle'
import { getDropdown } from '@/apis/Dictionary'
import { getPageList } from '@/apis/Form'
import { getDropdownByType } from '@/apis/tool'
import { salesmanUser } from '@/apis/user'

import { CostModel, ArrayRowsItem } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from '@/views/customer/invoiceInfo/FieldFrom'
import { TableField } from './FieldTable'
import mixin from '@/mixins/index'
import { defaultDate, pageVo, pageSizes } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Approvalinvoice',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const tableListRef = ref(null)
    const { t } = useI18n()
    const store = useStore()
    const userId = store.state.user.userId
    const dataMap = reactive({
      TableName: TableName.TABLE_APPROVAL_TICKETTITLE,
      permissionName: permissionName.APPROVAL_TICKETTITLE,
      initFormData: cloneDeep(FromFieldData),
      originFromFieldData: cloneDeep(FromFieldData),
      targetFromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,

      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        companyName: undefined,
        titleName: undefined,
        salesManId: undefined,
        changeStatus: undefined,
        ...pageVo,
        startTime: '',
        endTime: ''
      },
      pageSizes,
      dialogFormVisible: false,

      salesManOption: [],
      ReviewStatusOption: [],
      submitLoading: false,
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableListRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getReviewCompanyTicketTitleList(dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.list.map((item: any) => {
            if (item.customerCompanyId) {
              getPageList(`customerCompany/dropdown?ids=${item.customerCompanyId}`).then((res: any) => {
                item.customerCompanyName = res[0].mark
              })
            }
          })
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          companyName: undefined,
          titleName: undefined,
          salesManId: undefined,
          changeStatus: undefined,
          ...pageVo,
          startTime: defaultDate[0],
          endTime: defaultDate[1]
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        const {
          startTime,
          endTime
        } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }

        dataMap.getList()
      },

      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.originFromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.targetFromFieldData = cloneDeep(dataMap.initFormData)
        reviewCompanyTicketTitleById(row.id).then((res: any) => {
          const origin = res.origin
          dataMap.originFromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = origin[field.fieldKey] || field.value
              })
            }
          })
          dataMap.originFromFieldData = dataMap.originFromFieldData.filter((k: any) => k.type === 1)

          const target = res.target
          dataMap.targetFromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = target[field.fieldKey] || field.value
                switch (field.fieldKey) {
                }
              })
            }
          })
          dataMap.targetFromFieldData = dataMap.targetFromFieldData.filter((k: any) => k.type === 1)

          dataMap.originFromFieldData[0].formList.forEach((item: any) => {
            dataMap.targetFromFieldData[0].formList.forEach((k: any) => {
              if (item.fieldKey === k.fieldKey) {
                const _originValue = item.value ? item.value.toString() : item.value
                const _targetValue = k.value ? k.value.toString() : k.value
                if (_originValue !== _targetValue) {
                  item.config.colorTheme = 1
                  k.config.colorTheme = 2
                }
              }
            })
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      loadDropdownList(url: string) {
        getDropdown(url).then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      getDropdownByType(url: string) {
        getDropdownByType('ReviewStatus').then((res: any) => {
          dataMap[`${url}Option`] = res
        })
      },
      loadSalesMan() {
        salesmanUser().then((res: any) => {
          dataMap.salesManOption = res
        })
      },
      async handleSubmit(type: string) {
        try {
          if (type === 'reject') {
            await reviewRejectTicketTitle(dataMap.activeId)
          } else if (type === 'approve') {
            await reviewApproveTicketTitle(dataMap.activeId)
          }
          dataMap.dialogFormVisible = false
          dataMap.getList()
          ElMessage.success('操作成功！')
        } catch (err:any) {
          console.log(err, 'err')
        }
      },
      showSalesManFilter() {
        if (!dataMap.salesManOption.length) {
          return false
        }
        if (dataMap.salesManOption.length === 1 && dataMap.salesManOption[0].id === userId) {
          return false
        }
        return true
      }
    })
    const { mixinData } = mixin(dataMap)
    onMounted(async() => {
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.loadSalesMan()
      dataMap.getDropdownByType('ReviewStatus')
    })
    return { t, ...toRefs(dataMap), userId, ...toRefs(mixinData), tableListRef }
  }
})
</script>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
</style>
